/**
 * AM.One API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CsrfTokenResponse { 
    /**
     * CSRF token value to send with mutating browser requests.
     */
    token: string;
    /**
     * Request header name that carries the CSRF token.
     */
    headerName: CsrfTokenResponse.HeaderNameEnum;
}
export namespace CsrfTokenResponse {
    export const HeaderNameEnum = {
        XCsrfToken: 'X-CSRF-TOKEN'
    } as const;
    export type HeaderNameEnum = typeof HeaderNameEnum[keyof typeof HeaderNameEnum];
}


